import React from 'react'
import PropTypes from 'prop-types'

/*
 * This component encapsulates the update toggling logic
 * from other potential UX implementations of PhoneVerification.
 */
export default class Toggle extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  }

  state = {
    isToggled: false,
  }

  setToggle = newValue => {
    this.setState({
      isToggled: newValue,
    })
  }

  render() {
    return this.props.children
      ? this.props.children({
          isToggled: this.state.isToggled,
          setToggle: this.setToggle,
        })
      : null
  }
}
